import { getOperationAST } from "graphql";
export function getQueryDocumentKey(doc, operationName) {
    var ref;
    const op = getOperationAST(doc, operationName);
    var ref1;
    return (ref1 = op === null || op === void 0 ? void 0 : (ref = op.name) === null || ref === void 0 ? void 0 : ref.value) !== null && ref1 !== void 0 ? ref1 : null;
}
